import DinarReceiptSvg from '@assets/images/svg/dinar-receipt.svg';
import React from 'react';
import { View } from 'react-native';

export function DinarReceiptIcon({ size = 24, color = '#B3B3B3' }: { size?: number; color?: string }) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <DinarReceiptSvg width={size} height={size} color={color} />
        </View>
    );
}


